var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg271(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 720.355,
    height: 643.579,
    viewBox: "0 0 720.355 643.579",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_271",
    "data-name": "Grupo 271",
    transform: "translate(598.223 -213.894) rotate(60)",
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8259",
    "data-name": "Caminho 8259",
    d: "M59.18,1.322a9.869,9.869,0,0,1,9.87,0L123.294,32.64a9.871,9.871,0,0,1,4.935,8.549v62.634a9.87,9.87,0,0,1-4.935,8.549L69.05,143.69a9.869,9.869,0,0,1-9.87,0L4.935,112.372A9.87,9.87,0,0,1,0,103.823V41.189A9.871,9.871,0,0,1,4.935,32.64Z",
    transform: "matrix(-0.485, 0.875, -0.875, -0.485, 118.17, 522.031)",
    fill: "none",
    stroke: "#00a8ff",
    strokeWidth: 8.5,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8260",
    "data-name": "Caminho 8260",
    d: "M62.579,1.4a10.442,10.442,0,0,1,10.438,0l57.36,33.117a10.44,10.44,0,0,1,5.219,9.04v66.233a10.441,10.441,0,0,1-5.219,9.041l-57.36,33.117a10.436,10.436,0,0,1-10.438,0L5.218,118.827A10.437,10.437,0,0,1,0,109.788V43.555a10.439,10.439,0,0,1,5.218-9.04Z",
    transform: "translate(147.024 539.51) rotate(114.75)",
    fill: "none",
    stroke: "#14a7ff",
    strokeWidth: 8.768,
    opacity: 0.171
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8261",
    "data-name": "Caminho 8261",
    d: "M65.979,1.474a11.006,11.006,0,0,1,11.005,0l60.476,34.916a11,11,0,0,1,5.5,9.53v69.833a11.006,11.006,0,0,1-5.5,9.531L76.984,160.2a11,11,0,0,1-11.005,0L5.5,125.284a11,11,0,0,1-5.5-9.53V45.921a11,11,0,0,1,5.5-9.53Z",
    transform: "translate(176.506 553.316) rotate(110.5)",
    fill: "none",
    stroke: "#1da7ff",
    strokeWidth: 9.036,
    opacity: 0.201
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8262",
    "data-name": "Caminho 8262",
    d: "M69.379,1.55a11.576,11.576,0,0,1,11.573,0l63.593,36.715a11.572,11.572,0,0,1,5.786,10.022v73.431a11.572,11.572,0,0,1-5.786,10.022L80.952,168.456a11.576,11.576,0,0,1-11.573,0L5.786,131.74A11.572,11.572,0,0,1,0,121.718V48.287A11.572,11.572,0,0,1,5.786,38.265Z",
    transform: "translate(206.237 563.464) rotate(106.25)",
    fill: "none",
    stroke: "#23a6ff",
    strokeWidth: 9.304,
    opacity: 0.232
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8263",
    "data-name": "Caminho 8263",
    d: "M72.78,1.626a12.141,12.141,0,0,1,12.139,0l66.709,38.514a12.139,12.139,0,0,1,6.07,10.513v77.03a12.141,12.141,0,0,1-6.07,10.514L84.919,176.712a12.141,12.141,0,0,1-12.139,0L6.07,138.2A12.138,12.138,0,0,1,0,127.684V50.654A12.139,12.139,0,0,1,6.07,40.141Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 235.842, 569.996)",
    fill: "none",
    stroke: "#28a6ff",
    strokeWidth: 9.571,
    opacity: 0.263
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8264",
    "data-name": "Caminho 8264",
    d: "M76.179,1.7a12.705,12.705,0,0,1,12.707,0l69.826,40.314a12.706,12.706,0,0,1,6.353,11V133.65a12.707,12.707,0,0,1-6.353,11L88.886,184.968a12.708,12.708,0,0,1-12.707,0L6.353,144.653A12.7,12.7,0,0,1,0,133.65V53.021a12.706,12.706,0,0,1,6.353-11Z",
    transform: "translate(264.949 572.994) rotate(97.75)",
    fill: "none",
    stroke: "#2da5ff",
    strokeWidth: 9.839,
    opacity: 0.294
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8265",
    "data-name": "Caminho 8265",
    d: "M79.58,1.778a13.273,13.273,0,0,1,13.273,0L165.8,43.892a13.274,13.274,0,0,1,6.637,11.495v84.227a13.276,13.276,0,0,1-6.637,11.5L92.854,193.223a13.273,13.273,0,0,1-13.273,0L6.638,151.109A13.275,13.275,0,0,1,0,139.613V55.387A13.273,13.273,0,0,1,6.638,43.892Z",
    transform: "translate(293.208 572.566) rotate(93.5)",
    fill: "none",
    stroke: "#32a5ff",
    strokeWidth: 10.107,
    opacity: 0.324
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8266",
    "data-name": "Caminho 8266",
    d: "M82.98,1.854a13.838,13.838,0,0,1,13.84,0l76.06,43.912a13.841,13.841,0,0,1,6.92,11.987v87.825a13.841,13.841,0,0,1-6.92,11.987L96.82,201.479a13.838,13.838,0,0,1-13.84,0L6.92,157.566A13.841,13.841,0,0,1,0,145.579V57.754A13.841,13.841,0,0,1,6.92,45.767Z",
    transform: "matrix(0.013, 1, -1, 0.013, 320.273, 568.88)",
    fill: "none",
    stroke: "#36a4ff",
    strokeWidth: 10.375,
    opacity: 0.355
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8267",
    "data-name": "Caminho 8267",
    d: "M86.379,1.93a14.41,14.41,0,0,1,14.409,0l79.175,45.712a14.408,14.408,0,0,1,7.2,12.477v91.424a14.411,14.411,0,0,1-7.2,12.478l-79.175,45.712a14.413,14.413,0,0,1-14.409,0L7.2,164.021A14.407,14.407,0,0,1,0,151.544V60.12A14.407,14.407,0,0,1,7.2,47.642Z",
    transform: "translate(345.822 562.11) rotate(85)",
    fill: "none",
    stroke: "#39a3ff",
    strokeWidth: 10.643,
    opacity: 0.386
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8268",
    "data-name": "Caminho 8268",
    d: "M89.78,2.006a14.972,14.972,0,0,1,14.975,0l82.292,47.511a14.974,14.974,0,0,1,7.487,12.969v95.022a14.974,14.974,0,0,1-7.487,12.969L104.754,217.99a14.978,14.978,0,0,1-14.975,0L7.487,170.477A14.973,14.973,0,0,1,0,157.509V62.487A14.976,14.976,0,0,1,7.487,49.518Z",
    transform: "translate(369.543 552.461) rotate(80.75)",
    fill: "none",
    stroke: "#3da3ff",
    strokeWidth: 10.911,
    opacity: 0.416
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8269",
    "data-name": "Caminho 8269",
    d: "M93.179,2.081a15.545,15.545,0,0,1,15.543,0l85.408,49.31a15.544,15.544,0,0,1,7.771,13.46v98.622a15.544,15.544,0,0,1-7.771,13.46l-85.408,49.31a15.542,15.542,0,0,1-15.543,0L7.771,176.934A15.542,15.542,0,0,1,0,163.474V64.852a15.542,15.542,0,0,1,7.771-13.46Z",
    transform: "matrix(0.233, 0.972, -0.972, 0.233, 391.182, 540.177)",
    fill: "none",
    stroke: "#40a2ff",
    strokeWidth: 11.179,
    opacity: 0.447
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8270",
    "data-name": "Caminho 8270",
    d: "M96.58,2.158a16.107,16.107,0,0,1,16.109,0l88.525,51.11a16.11,16.11,0,0,1,8.055,13.951V169.439a16.112,16.112,0,0,1-8.055,13.952L112.689,234.5a16.107,16.107,0,0,1-16.109,0L8.055,183.39A16.108,16.108,0,0,1,0,169.439V67.22A16.11,16.11,0,0,1,8.055,53.268Z",
    transform: "matrix(0.305, 0.952, -0.952, 0.305, 410.458, 525.512)",
    fill: "none",
    stroke: "#43a2ff",
    strokeWidth: 11.446,
    opacity: 0.478
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8271",
    "data-name": "Caminho 8271",
    d: "M99.98,2.234a16.677,16.677,0,0,1,16.676,0L208.3,55.143a16.676,16.676,0,0,1,8.338,14.442V175.4a16.68,16.68,0,0,1-8.338,14.443l-91.642,52.908a16.675,16.675,0,0,1-16.676,0L8.338,189.845A16.674,16.674,0,0,1,0,175.4V69.585A16.674,16.674,0,0,1,8.338,55.143Z",
    transform: "matrix(0.375, 0.927, -0.927, 0.375, 427.174, 508.761)",
    fill: "none",
    stroke: "#46a1ff",
    strokeWidth: 11.714,
    opacity: 0.509
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8272",
    "data-name": "Caminho 8272",
    d: "M103.381,2.31a17.242,17.242,0,0,1,17.243,0l94.758,54.708A17.242,17.242,0,0,1,224,71.953V181.369a17.244,17.244,0,0,1-8.621,14.934l-94.758,54.708a17.245,17.245,0,0,1-17.243,0L8.623,196.3A17.242,17.242,0,0,1,0,181.369V71.953A17.244,17.244,0,0,1,8.623,57.019Z",
    transform: "translate(441.108 490.223) rotate(63.75)",
    fill: "none",
    stroke: "#49a0ff",
    strokeWidth: 11.982,
    opacity: 0.539
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8273",
    "data-name": "Caminho 8273",
    d: "M106.779,2.386a17.814,17.814,0,0,1,17.812,0l97.874,56.508a17.809,17.809,0,0,1,8.906,15.424V187.334a17.812,17.812,0,0,1-8.906,15.425l-97.874,56.507a17.814,17.814,0,0,1-17.812,0L8.906,202.758A17.811,17.811,0,0,1,0,187.334V74.318A17.815,17.815,0,0,1,8.906,58.893Z",
    transform: "translate(452.107 470.226) rotate(59.5)",
    fill: "none",
    stroke: "#4ca0ff",
    strokeWidth: 12.25,
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8274",
    "data-name": "Caminho 8274",
    d: "M110.179,2.462a18.376,18.376,0,0,1,18.378,0L229.548,60.769a18.379,18.379,0,0,1,9.189,15.916V193.3a18.381,18.381,0,0,1-9.189,15.916L128.557,267.522a18.376,18.376,0,0,1-18.378,0L9.189,209.214A18.376,18.376,0,0,1,0,193.3V76.685A18.38,18.38,0,0,1,9.189,60.768Z",
    transform: "translate(460.04 449.101) rotate(55.25)",
    fill: "none",
    stroke: "#4e9fff",
    strokeWidth: 12.518,
    opacity: 0.601
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8275",
    "data-name": "Caminho 8275",
    d: "M113.58,2.537a18.949,18.949,0,0,1,18.946,0L236.632,62.644A18.944,18.944,0,0,1,246.1,79.051V199.263a18.946,18.946,0,0,1-9.472,16.408L132.526,275.777a18.944,18.944,0,0,1-18.946,0L9.472,215.67A18.945,18.945,0,0,1,0,199.263V79.051A18.95,18.95,0,0,1,9.472,62.643Z",
    transform: "translate(464.805 427.191) rotate(51)",
    fill: "none",
    stroke: "#519fff",
    strokeWidth: 12.786,
    opacity: 0.631
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8276",
    "data-name": "Caminho 8276",
    d: "M116.98,2.614a19.509,19.509,0,0,1,19.512,0l107.224,61.9a19.513,19.513,0,0,1,9.756,16.9v123.81a19.513,19.513,0,0,1-9.756,16.9L136.492,284.033a19.509,19.509,0,0,1-19.512,0L9.755,222.127A19.513,19.513,0,0,1,0,205.229V81.418a19.516,19.516,0,0,1,9.755-16.9Z",
    transform: "matrix(0.685, 0.728, -0.728, 0.685, 466.345, 404.854)",
    fill: "none",
    stroke: "#539eff",
    strokeWidth: 13.054,
    opacity: 0.662
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8277",
    "data-name": "Caminho 8277",
    d: "M120.381,2.689a20.079,20.079,0,0,1,20.079,0L250.8,66.395a20.079,20.079,0,0,1,10.04,17.389v127.41a20.081,20.081,0,0,1-10.04,17.39l-110.341,63.7a20.079,20.079,0,0,1-20.079,0L10.04,228.583A20.08,20.08,0,0,1,0,211.194V83.784a20.085,20.085,0,0,1,10.04-17.39Z",
    transform: "translate(464.627 382.455) rotate(42.5)",
    fill: "none",
    stroke: "#569dff",
    strokeWidth: 13.321,
    opacity: 0.693
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8278",
    "data-name": "Caminho 8278",
    d: "M123.779,2.765a20.649,20.649,0,0,1,20.647,0l113.456,65.5a20.647,20.647,0,0,1,10.324,17.881V217.159a20.649,20.649,0,0,1-10.324,17.881l-113.456,65.5a20.649,20.649,0,0,1-20.647,0l-113.456-65.5A20.645,20.645,0,0,1,0,217.159V86.151A20.65,20.65,0,0,1,10.323,68.269Z",
    transform: "matrix(0.785, 0.619, -0.619, 0.785, 459.66, 360.345)",
    fill: "none",
    stroke: "#589dff",
    strokeWidth: 13.589,
    opacity: 0.724
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8279",
    "data-name": "Caminho 8279",
    d: "M127.18,2.842a21.214,21.214,0,0,1,21.214,0l116.574,67.3a21.213,21.213,0,0,1,10.606,18.371V223.124A21.216,21.216,0,0,1,264.967,241.5L148.394,308.8a21.214,21.214,0,0,1-21.214,0l-116.573-67.3A21.214,21.214,0,0,1,0,223.124V88.517A21.217,21.217,0,0,1,10.607,70.144Z",
    transform: "matrix(0.829, 0.559, -0.559, 0.829, 451.483, 338.887)",
    fill: "none",
    stroke: "#5a9cff",
    strokeWidth: 13.857,
    opacity: 0.754
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8280",
    "data-name": "Caminho 8280",
    d: "M130.58,2.918a21.781,21.781,0,0,1,21.781,0l119.689,69.1a21.78,21.78,0,0,1,10.891,18.863v138.2a21.783,21.783,0,0,1-10.891,18.864l-119.689,69.1a21.781,21.781,0,0,1-21.781,0l-119.689-69.1A21.78,21.78,0,0,1,0,229.089V90.884A21.783,21.783,0,0,1,10.891,72.02Z",
    transform: "matrix(0.868, 0.496, -0.496, 0.868, 440.174, 318.434)",
    fill: "none",
    stroke: "#5d9bff",
    strokeWidth: 14.125,
    opacity: 0.785
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8281",
    "data-name": "Caminho 8281",
    d: "M133.98,2.993a22.351,22.351,0,0,1,22.348,0L279.134,73.9A22.348,22.348,0,0,1,290.308,93.25v141.8a22.351,22.351,0,0,1-11.174,19.355l-122.807,70.9a22.346,22.346,0,0,1-22.348,0l-122.806-70.9A22.348,22.348,0,0,1,0,235.053V93.25A22.351,22.351,0,0,1,11.174,73.895Z",
    transform: "matrix(0.903, 0.431, -0.431, 0.903, 425.855, 299.325)",
    fill: "none",
    stroke: "#5f9bff",
    strokeWidth: 14.393,
    opacity: 0.816
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8282",
    "data-name": "Caminho 8282",
    d: "M137.38,3.07a22.913,22.913,0,0,1,22.915,0l125.922,72.7a22.916,22.916,0,0,1,11.457,19.845v145.4a22.916,22.916,0,0,1-11.457,19.845L160.3,333.566a22.918,22.918,0,0,1-22.915,0l-125.922-72.7A22.912,22.912,0,0,1,0,241.019V95.617A22.918,22.918,0,0,1,11.458,75.77Z",
    transform: "translate(408.658 281.896) rotate(21.25)",
    fill: "none",
    stroke: "#619aff",
    strokeWidth: 14.661,
    opacity: 0.846
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8283",
    "data-name": "Caminho 8283",
    d: "M140.78,3.145a23.483,23.483,0,0,1,23.482,0L293.3,77.646a23.482,23.482,0,0,1,11.741,20.336v149A23.483,23.483,0,0,1,293.3,267.32l-129.039,74.5a23.483,23.483,0,0,1-23.482,0l-129.04-74.5A23.481,23.481,0,0,1,0,246.984v-149A23.486,23.486,0,0,1,11.74,77.645Z",
    transform: "translate(388.77 266.461) rotate(17)",
    fill: "none",
    stroke: "#639aff",
    strokeWidth: 14.929,
    opacity: 0.877
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8284",
    "data-name": "Caminho 8284",
    d: "M144.181,3.221a24.05,24.05,0,0,1,24.049,0l132.155,76.3a24.05,24.05,0,0,1,12.025,20.827v152.6a24.052,24.052,0,0,1-12.025,20.828l-132.155,76.3a24.051,24.051,0,0,1-24.049,0l-132.156-76.3A24.048,24.048,0,0,1,0,252.949v-152.6A24.053,24.053,0,0,1,12.025,79.521Z",
    transform: "matrix(0.975, 0.221, -0.221, 0.975, 366.398, 253.327)",
    fill: "none",
    stroke: "#6599ff",
    strokeWidth: 15.196,
    opacity: 0.908
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8285",
    "data-name": "Caminho 8285",
    d: "M147.58,3.3a24.618,24.618,0,0,1,24.617,0L307.468,81.4a24.615,24.615,0,0,1,12.309,21.318v156.2a24.618,24.618,0,0,1-12.309,21.318L172.2,358.332a24.618,24.618,0,0,1-24.617,0l-135.272-78.1A24.616,24.616,0,0,1,0,258.914v-156.2A24.62,24.62,0,0,1,12.308,81.4Z",
    transform: "translate(341.786 242.768) rotate(8.5)",
    fill: "none",
    stroke: "#6798ff",
    strokeWidth: 15.464,
    opacity: 0.939
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8286",
    "data-name": "Caminho 8286",
    d: "M150.981,3.373a25.185,25.185,0,0,1,25.184,0l138.388,79.9a25.185,25.185,0,0,1,12.591,21.809v159.8a25.187,25.187,0,0,1-12.591,21.81l-138.388,79.9a25.185,25.185,0,0,1-25.184,0l-138.388-79.9A25.182,25.182,0,0,1,0,264.879v-159.8a25.187,25.187,0,0,1,12.592-21.81Z",
    transform: "translate(315.189 235.037) rotate(4.25)",
    fill: "none",
    stroke: "#6998ff",
    strokeWidth: 15.732,
    opacity: 0.969
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8287",
    "data-name": "Caminho 8287",
    d: "M404.38,233.817a25.755,25.755,0,0,1,25.751,0l141.5,81.7a25.749,25.749,0,0,1,12.875,22.3v163.4a25.755,25.755,0,0,1-12.875,22.3l-141.5,81.7a25.755,25.755,0,0,1-25.751,0l-141.505-81.7A25.752,25.752,0,0,1,250,501.212v-163.4a25.755,25.755,0,0,1,12.875-22.3Z",
    transform: "translate(36.907)",
    fill: "none",
    stroke: "#6b97ff",
    strokeWidth: 16
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg271);
export default __webpack_public_path__ + "static/media/271.0a204d300f6e9c926deb7936294a0756.svg";
export { ForwardRef as ReactComponent };